import { createStyles, makeStyles } from '@mui/styles';
import { Colors } from 'copyright-clearance-center-common-ui';

const useStyles = makeStyles(() =>
	createStyles({
		spaceDivider: {
			display: 'inline-flex',
			padding: '0px 4px'
		},
		divider: {
			width: '1px',
			height: '0.75rem',
			background: Colors.neutral300
		}
	})
);

export interface IDividerProps {
	spaceDividerClass?: string;
	dividerClass?: string;
}

const Divider: React.FunctionComponent<IDividerProps> = props => {
	const classes = useStyles();

	return (
		<div className={props.spaceDividerClass ?? classes.spaceDivider}>
			<div className={props.dividerClass ?? classes.divider} />
		</div>
	);
};

export default Divider;
